import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Link,
  Typography, CardContent
} from '@material-ui/core';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { MessageValues } from '../../values/MessageValues';
import Card from '@material-ui/core/Card';
import Alert from '@material-ui/lab/Alert';


const useStyles = makeStyles(theme => ({
  root: {
    margin: 20
  },
  spacer: {
    flexGrow: 1
  },
  text1Root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      marginTop: theme.spacing(2),
      width: '100%',
    },
  },
  text1Container: {
    paddingTop: theme.spacing(2),
    textAlign: 'center'
  },
  text2Root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      width: '100%',
    },
  },
  text2Container: {
    textAlign: 'center'
  }
}));

const RecuperacaoSenha = props => {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const { history } = props;
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [success, setSuccess] = useState(false);

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  async function enviarEmail(event) {
    event.preventDefault();
    try {
      setLoading(true);
      let info = {
        email: email
      };
      let auth = await api.post('/email/email-recuperacao-senha', info);
      if (auth) {
        if (auth.data.isSuccess) {
          setLoading(false);
          setSuccess(true);

        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(auth.data.message);
          setShowMessageSnack(true);
        }
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }

  return (
    <ValidatorForm
      onSubmit={e => enviarEmail(e)}
    >
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <SnackbarCustom
        verticalOrientation='bottom'
        horizontalOrientation='center'
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />
      <Card className={classes.root}>
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              md={6}
              xs={12}
            >
              <div
                className={classes.text1Root}
              >
                <div
                  className={classes.text1Container}
                >
                  <Typography variant="h3" color="textPrimary" gutterBottom>
                    Recuperação de senha
                  </Typography>
                </div>

              </div>

            </Grid>
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              md={3}
            >
            </Grid>
            {
              success ?
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <Alert severity="success">Email de recuperação enviado com sucesso. Verifique sua caixa de entrada!</Alert>
                </Grid>

              :
                <Grid
                  md={6}
                  xs={12}
                >
                  <div
                    className={classes.text1Root}
                  >
                    <div
                      className={classes.text1Container}
                    >
                      <Typography variant="h6" color="textSecondary" gutterBottom>
                        Informe o seu email para recuperação de senha. Caso seu email esteja vinculado a um usuário do sistema
                        iremos lhe enviar um email com algumas informações.
                      </Typography>
                    </div>
                  </div>
                </Grid>
            }
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              md={6}
              xs={12}
            >
              {
                !success &&
                <TextValidator
                  fullWidth
                  label="Email"
                  helperText="Insira aqui o email que está vinculado ao seu usuário."
                  margin="dense"
                  name="login"
                  onChange={e => setEmail(e.target.value)}
                  value={email}
                  variant="outlined"
                  validators={['required', 'isEmail']}
                  errorMessages={['Insira o login ou email do usuário.', 'Informe um email válido!']}
                />
              }

            </Grid>
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              md={3}
            >
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >

              {
                !success &&
                <Button
                  className={classes.signInButton}
                  color="primary"
                  margin={'dense'}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Enviar
                </Button>
              }
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    </ValidatorForm>

  );
};

RecuperacaoSenha.propTypes = {
  history: PropTypes.object
};

export default withRouter(RecuperacaoSenha);
